/**
 * Formatar strings
 */
import Vue from "vue";
Vue.filter("filterEllipsis", function(stringValue, countLetters) {
  return String(stringValue).substring(0, countLetters) + "...";
});
